import { Link } from "react-router-dom";
import styles from "./Banner.module.css";
import ImageBanner from "./ImageBanner/ImageBanner";
import { useEffect, useState } from "react";
import axios from "axios";

function Banner() {
    const [user, setUser] = useState(null);

    useEffect(() => {
        axios.get("https://eclipsebots.com/api/profile", { withCredentials: true })
            .then((res) => setUser(res.data))
            .catch(() => setUser(null));
    }, []);

    return (
        <div className={styles.divider}>
            <div className={styles.imagens}>
                <ImageBanner />
            </div>
            <div className={styles.text}>
                <h1>Automatize o seu servidor com nossos bots!</h1>
                <p>
                    Tenha uma experiência completa com nosso <strong>painel exclusivo</strong>, onde você controla seus serviços com total autonomia.
                    Chegou a hora de evoluir o seu servidor com <label className={styles.strong}>praticidade</label> e <label className={styles.strong}>inovação</label> com planos que acompanham seu crescimento.</p>
                <div className={styles.buttons}>
                    <Link to={"/planos"} className={styles.topic}>
                        <button>Ver Planos</button>
                    </Link>
                    {!user && (
                        <a href={"https://discord.com/oauth2/authorize?client_id=1368164502360555590&response_type=code&redirect_uri=https%3A%2F%2Feclipsebots.com%2Flogin%2Fdiscord%2Fcallback&scope=identify+guilds.join+email"} className={styles.topic}>
                            <button>Login com Discord</button>
                        </a>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Banner;